const findClosedDefinedIndex = (arr: unknown[], index: number): number => {
  const roundIndex = Math.round(index)
  for (let distance = 0; roundIndex - distance > 0 || roundIndex + distance < arr.length; distance++) {
    if (!!arr[roundIndex - distance]) {
      return roundIndex - distance
    }
    if (!!arr[roundIndex + distance]) {
      return roundIndex + distance
    }
  }
  return roundIndex
}

export default findClosedDefinedIndex
